<template>
  <v-card class="elevation-2">
    <v-card-title class="d-flex justify-space-between align-center">
      <span>Torneos Disponibles</span>
      <v-chip color="primary" small text-color="white">
        {{ tournaments.length }}
      </v-chip>
    </v-card-title>
    <v-divider></v-divider>

    <!-- Filtros -->
    <v-card-text class="py-4">
      <v-row dense>
        <v-col cols="12" sm="6" md="4">
          <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            label="Buscar torneo"
            outlined
            dense
            clearable
            @input="applyFilters"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-select
            v-model="statusFilter"
            :items="statusOptions"
            item-text="text"
            item-value="value"
            label="Estado"
            outlined
            dense
            clearable
            @change="applyFilters"
          ></v-select>
        </v-col>
      </v-row>
    </v-card-text>

    <v-divider></v-divider>

    <!-- Lista de torneos -->
    <v-card-text>
      <v-progress-linear v-if="loading" indeterminate></v-progress-linear>

      <div v-if="!loading && filteredTournaments.length === 0" class="text-center py-8">
        <v-icon large color="grey lighten-1" class="mb-3">mdi-inbox-outline</v-icon>
        <p class="grey--text">No hay torneos disponibles</p>
      </div>

      <v-row v-else>
        <v-col v-for="tournament in filteredTournaments" :key="tournament.id" cols="12" md="6" lg="4">
          <TournamentCard
            :tournament="tournament"
            :is-rp="isRp"
            @register="$emit('register', tournament)"
            @view="$emit('view', tournament)"
            @edit="$emit('edit', tournament)"
            @delete="$emit('delete', tournament)"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import TournamentCard from './components/TournamentCard.vue'

export default {
  name: 'TournamentsList',
  components: {
    TournamentCard
  },
  props: {
    tournaments: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    isRp: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      search: '',
      statusFilter: null,
      statusOptions: [
        { text: 'Pendiente', value: 1 },
        { text: 'Confirmado', value: 2 },
        { text: 'En curso', value: 4 },
        { text: 'Finalizado', value: 5 }
      ]
    }
  },
  computed: {
    filteredTournaments () {
      return (this.tournaments || []).filter(tournament => {
        const matchesSearch = !this.search ||
          tournament.name.toLowerCase().includes(this.search.toLowerCase()) ||
          (tournament.description && tournament.description.toLowerCase().includes(this.search.toLowerCase()))

        const matchesStatus = !this.statusFilter || tournament.status === this.statusFilter

        return matchesSearch && matchesStatus
      })
    }
  },
  methods: {
    applyFilters () {
      this.$emit('filter', {
        search: this.search,
        status: this.statusFilter
      })
    }
  }
}
</script>

<style scoped>
.v-card-text {
  padding: 16px;
}
</style>
